import React from 'react';

const CustomButton = ({
  text,
  onClick,
  disabled = false,
  variant = 'solid',
  className = '',
  ...props
}) => {
  const baseClasses = `
    flex items-center justify-center text-center
    px-2 py-2.5
    max-w-40
    font-semibold
    rounded-full
    text-sm
    transition-colors duration-200
    shadow-none
    tracking-wide
    whitespace-nowrap
    focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-offset-2
    disabled:opacity-60 disabled:cursor-not-allowed
  `;

  const variantClasses =
    variant === 'outline'
      ? 'bg-transparent text-apple-blue border-2 border-apple-blue hover:bg-blue-50'
      : 'bg-apple-blue text-white hover:bg-blue-700';

  const buttonClasses = `${baseClasses} ${variantClasses} ${className}`;

  return (
    <button onClick={onClick} disabled={disabled} className={buttonClasses + ' group'} {...props}>
      <span>{text}</span>
    </button>
  );
};

export default CustomButton;
